import { Disposable } from '../DisposableContainer/DisposableContainer';

export class TimingUtils {
  private constructor() {}

  public static withTimeout<T>(
    workerPromise: Promise<T>,
    timeoutMs: number
  ): Promise<T> {
    let timeoutHandle: number | null = null;
    const timeoutPromise = new Promise<T>((_, reject) => {
      timeoutHandle = window.setTimeout(() => {
        reject(new Error('Operation timed out'));
      }, timeoutMs);
    });

    const promise = Promise.race([workerPromise, timeoutPromise]);

    void promise.finally(() => {
      if (timeoutHandle) {
        window.clearTimeout(timeoutHandle);
      }
    });

    return promise;
  }

  public static waitForPromisesToFinish(): Promise<void> {
    return this.wait(0);
  }

  public static wait(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  public static setTimeout(callback: () => void, ms: number): Disposable {
    const handle = setTimeout(callback, ms);
    return {
      dispose: () => {
        clearTimeout(handle);
      }
    };
  }

  public static requestAnimationFrame(
    callback: FrameRequestCallback
  ): Disposable {
    const handle = requestAnimationFrame(callback);

    return {
      dispose: () => {
        cancelAnimationFrame(handle);
      }
    };
  }

  public static queueMicrotask(callback: () => void): Disposable {
    let disposed = false;
    queueMicrotask(() => {
      if (!disposed) {
        callback();
      }
    });

    return {
      dispose: () => {
        disposed = true;
      }
    };
  }
}
